/**
 * ProfileAddressesApi — RTK Query API for updating user profile.
 *
 * Provides `useUpdateProfileMutation` for saving addresses to
 * `currentUser.attributes.profile.protectedData.addresses`.
 *
 * This API is separate from UserApi (favourites) so profileAddresses
 * can be enabled independently.
 */

import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react';
import { setCurrentUser } from '../../ducks/user.duck';
import { denormalisedResponseEntities } from '../../util/data';

export const ProfileAddressesApi = createApi({
  reducerPath: 'ProfileAddressesApi',
  tagTypes: ['UserProfile'],
  baseQuery: fakeBaseQuery(),
  endpoints: builder => ({
    updateProfile: builder.mutation({
      queryFn: async (arg, queryApi) => {
        const { dispatch, extra: sdk } = queryApi;
        const queryParams = {
          expand: true,
          include: ['profileImage'],
          'fields.image': ['variants.square-small', 'variants.square-small2x'],
        };
        const response = await sdk.currentUser.updateProfile(arg, queryParams);
        const entities = denormalisedResponseEntities(response);
        if (entities.length !== 1) {
          throw new Error('Expected a resource in the sdk.currentUser.updateProfile response');
        }
        const currentUser = entities[0];
        dispatch(setCurrentUser(currentUser));
        return { data: currentUser };
      },
      invalidatesTags: ['UserProfile'],
    }),
  }),
});

export const { useUpdateProfileMutation } = ProfileAddressesApi;
